// @flow
import type {AbstractComponent, Node} from 'react'
import React, {Component} from 'react'
import {createFragmentContainer, graphql} from 'react-relay'
import type {$RelayProps} from 'react-relay'
import Select from 'react-select'
import {compose, map} from 'ramda'
import classNames from 'classnames'

import FormGroup from 'components/ui/FormGroup'
import type {Option} from 'components/proposals/types'
import {liftEdges} from 'utils/GraphQL'
import type {
  SupportedRoleSelect_proposal as Proposal,
} from './__generated__/SupportedRoleSelect_proposal.graphql'

const makeOption = ({currentlyUpdating, node: {databaseId, localizedName}}): Option => (
  {
    label: localizedName,
    value: databaseId,
    type: 'MoveItems',
    isDisabled: currentlyUpdating,
  }
)

const makeOptions = compose(map(makeOption), liftEdges('availableSupportedRoles'))

type Props = {
  className: string,
  disabled: boolean,
  onChange: (command: string, typename: string) => any,
  proposal: Proposal,
}

class SupportedRoleSelect extends Component<Props> {
  static defaultProps: { className: string } = {
    className: '',
  }

  onChange: ((option: Option) => void) = (option: Option) => {
    const {value: databaseId, type} = option
    const command = JSON.stringify({
      childRoleDatabaseId: databaseId,
      type,
    })
    this.props.onChange(command, 'MoveItemsChange')
  }

  get proposalDatabaseId(): string {
    return this.props.proposal.databaseId
  }

  get options(): Option[] {
    return makeOptions(this.props.proposal)
  }

  get className(): string {
    return classNames(this.props.className, 'refinery-select')
  }

  get target(): string {
    return `PartSelector-${this.proposalDatabaseId}-move-items-select`
  }

  // eslint-disable-next-line react/no-arrow-function-lifecycle
  render: (() => Node) = () => (
    <FormGroup
      label={I18n.t('proposals.circle_restructure.restructure_subcircle2')}
      small
      target={this.target}
    >
      <Select
        isDisabled={this.props.disabled}
        className={this.className}
        classNamePrefix="Select"
        inputId={this.target}
        noOptionsMessage={() => I18n.t('shared.no_results_found')}
        value={null}
        onChange={this.onChange}
        options={this.options}
        placeholder={I18n.t('proposals.rewrite.select_input_choose_circle')}
      />
    </FormGroup>
  )
}

export default (createFragmentContainer(SupportedRoleSelect, {
  proposal: graphql`
    fragment SupportedRoleSelect_proposal on Proposal {
      databaseId
      
      availableSupportedRoles {
        edges {
          currentlyUpdating

          node {
            databaseId
            localizedName
          }
        }
      }
    }
  `,
}): AbstractComponent<
  $RelayProps<React$ElementConfig<typeof SupportedRoleSelect>>,
  SupportedRoleSelect,
>)
